import { render } from "./AppNavbarMenu.vue?vue&type=template&id=67c5a848"
import script from "./AppNavbarMenu.vue?vue&type=script&lang=js"
export * from "./AppNavbarMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__